import React from 'react';
import * as Yup from 'yup';
import _isArray from 'lodash/isArray';
import { ButtonStyled, LoginErrorMessage } from './Login.style';

export const createValidationSchema = ({ requirePassword = false } = {}) =>
  Yup.object().shape({
    email: Yup.string().trim().email('Enter a valid email address').required('Email address is required'),
    ...(requirePassword
      ? {
          password: Yup.string()
            .trim()
            .required('Password is required'),
        }
      : {}),
  });

export const createInitialValues = ({ includePassword = false } = {}) => ({
  email: '',
  ...(includePassword ? { password: '' } : {}),
});

export const renderErrorMessage = (error, index) => <p key={index}>{error}</p>;

export const renderErrorList = (errorList) => {
  if (!errorList) return null;
  if (_isArray(errorList)) {
    return (
      <LoginErrorMessage>
        {errorList.map(renderErrorMessage)}
      </LoginErrorMessage>
    );
  }
  return (
    <LoginErrorMessage>
      {renderErrorMessage(errorList, 1)}
    </LoginErrorMessage>
  );
};

export const renderLoginButton = (isLoading) =>
  isLoading ? (
    <ButtonStyled primary>Loading ...</ButtonStyled>
  ) : (
    <ButtonStyled type="submit">Log In</ButtonStyled>
  );

